import React from "react";
import { Link } from "react-router-dom";
import { handleHomeSectionClick } from "./homeSectionNav";

function UserHeader() {
  const menuItems = [
    {
      name: "About AstroAdi",
      link: "/page/user-about-us",
    },
    {
      name: "Services",
      link: "/services",
    },
    {
      name: "Remedies Store",
      link: "/remedies-store",
    },
    {
      name: "Download App",
      link: "/download-app",
    },
    {
      name: "FAQ",
      link: "/faq",
    },
  ];

  const closeDrawer = () => {
    const drawerCheckbox = document.getElementById("my-drawer-3");
    if (drawerCheckbox) {
      drawerCheckbox.checked = false;
    }
  };

  const handleNavClick = (link, e) => {
    closeDrawer();
    handleHomeSectionClick(e, link);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 py-[15px]">
        <div className="drawer">
          <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
          <div className="drawer-content flex flex-col">
            {/* Navbar */}
            <div className="navbar p-0 w-full">
              <div className="container">
                <div className="header-inner flex items-center gap-[15px] w-full px-[5px] md:px-[20px] py-[10px]">
                  <div className="head-left flex items-center gap-[15px]">
                    <div className="flex-none lg:hidden">
                      <label
                        htmlFor="my-drawer-3"
                        aria-label="open sidebar"
                        className="btn btn-square btn-ghost !p-0 !flex !items-center !justify-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          className="inline-block h-6 w-6 stroke-current"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            stroke="#fff"
                            d="M4 6h16M4 12h16M4 18h16"
                          ></path>
                        </svg>
                      </label>
                    </div>

                    <Link to="/" className="logo">
                      <img
                        src="/images/white-logo.svg"
                        alt="logo"
                        className="max-w-[120px] lg:max-w-[177px]"
                      />
                    </Link>
                  </div>

                  <div className="hidden head-right lg:flex items-center gap-[15px] flex-1">
                    <ul className="menu menu-horizontal m-0 flex-1 flex items-center gap-[5px] justify-center">
                      {/* Navbar menu content here */}
                      {menuItems.map((item, index) => (
                        <li key={index}>
                          <Link
                            to={item.link}
                            onClick={(e) => handleNavClick(item.link, e)}
                            className="web-h6 text-white no-underline hover:text-yellow-400 transition-colors"
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                    {/* Login / Sign Up — hidden for now, keep space so nav stays aligned */}
                    <ul className="flex items-center gap-[15px] m-0 invisible pointer-events-none" aria-hidden="true">
                      <li>
                        <Link to="/sign-up" className="custom-btn custom-btn-primary no-underline" tabIndex={-1}>
                          Sign Up
                        </Link>
                      </li>
                      <li>
                        <Link to="/login" className="custom-btn custom-btn-white no-underline" tabIndex={-1}>
                          Log In
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="drawer-side">
            <label
              htmlFor="my-drawer-3"
              aria-label="close sidebar"
              className="drawer-overlay"
            ></label>
            <ul className="menu bg-base-200 min-h-full flex flex-col gap-[5px] w-80 p-4">
              {/* Sidebar content here */}
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.link}
                    onClick={(e) => handleNavClick(item.link, e)}
                    className="web-h6 text-black hover:no-underline bold"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li className="hidden">
                <Link to="/login" className="web-h6 text-black hover:no-underline bold">
                  Log In
                </Link>
                <Link to="/sign-up" className="web-h6 text-black hover:no-underline bold">
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  );
}

export default UserHeader;
